import { Link } from "react-router-dom";
import { CONTENT } from "@/content";
import { scrollToSection } from "@/components/Navbar";

const Footer = () => (
  <footer className="bg-ivory" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-12">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <button data-testid="footer-logo" onClick={() => scrollToSection("#hero")} className="text-left leading-none">
          <img src="/logo-full.png" alt={`${CONTENT.name} — ${CONTENT.title}`} className="logo-ink h-24 w-auto" />
        </button>
        <p className="max-w-xs font-serif text-lg font-light italic leading-relaxed text-taupe">
          « Un univers éditorial consacré au corps, au mouvement et à la santé. »
        </p>
      </div>
      <div className="gold-rule mt-12" />
      <div className="mt-8 flex flex-col items-start justify-between gap-4 text-[11px] uppercase tracking-[0.2em] text-taupe/70 md:flex-row md:items-center">
        <p data-testid="footer-copyright">© 2026 {CONTENT.name} — {CONTENT.title}</p>
        <div className="flex gap-8">
          <a href={CONTENT.instagramUrl} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-anthracite" data-testid="footer-instagram-link">
            Instagram
          </a>
          <Link to="/mentions-legales" className="transition-colors hover:text-anthracite" data-testid="footer-legal-link">
            Mentions légales
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
